export var WalletTypeEnum;
(function (WalletTypeEnum) {
    WalletTypeEnum["ALL_ASSETS"] = "ALL_ASSETS";
    WalletTypeEnum["NON_ZERO_ASSETS"] = "NON_ZERO_ASSETS";
    WalletTypeEnum["FAVORITE_ASSETS"] = "FAVORITE_ASSETS";
})(WalletTypeEnum || (WalletTypeEnum = {}));
//# sourceMappingURL=wallet-type.enum.js.map